<template>
  <div>
    <!-- 9856 codigo yisus -->
    <v-form ref="formDatos" lazy-validation>

      <ComunDialogComp v-model="estadoComp" maxWidth="1500" :classCardText="'pt-0'" @close-modal="cerrarModal">

        <template v-slot:title>
          {{ next == 'seleccionarClase' && datosSelecClase.evento == 'agregar' ? 'Seleccionar clase' : next ==
            'programarClase' && datosSelecClase.evento == 'agregar' ? 'Programar clase' : next == 'programarClase' &&
              datosSelecClase.evento == 'ver' ? 'Sesión de aprendizaje' : 'Editar programación' }}
          <v-tooltip v-if="datosSelecClase.evento == 'ver'" bottom color="#1b1b1b">
            <template v-slot:activator="{ on }">
              <v-btn class="mx-2 btn_ver" v-on="on" :loading="descargandoDocumento" fab x-small
                @click="GenerarDocumento">
                <v-icon>fa-file-download</v-icon>
              </v-btn>
            </template>
            <span>Descargar sesión</span>
          </v-tooltip>
        </template>


        <template v-slot:body>

          <v-stepper flat :hide-stepper-header="true" v-model="next">

            <v-stepper-items>

              <v-stepper-content step="seleccionarClase">

                <v-row>

                  <v-col cols="12" sm="3" md="auto">
                    <span><strong>Contenidos</strong>
                    </span>
                    <v-skeleton-loader class="skeletonTic" v-if="nivelContManager.length === 0"
                      type="avatar, text, avatar, text">
                    </v-skeleton-loader>

                    <v-radio-group v-else v-model="asociarCl.contenidoTipo" @change="cargarQueryContenido($event)" row
                      class="mt-0">
                      <v-radio label="Inteligenio" :value="1"></v-radio>
                      <v-radio label="Colegio" :value="0"></v-radio>
                    </v-radio-group>
                  </v-col>

                  <v-col cols="12" sm="3" md="">
                    <v-autocomplete label="Nivel" v-model="asociarCl.id_nivel" :items="nivelCont"
                      :item-value="id_nivelFiltro" item-text="desc_nivel" @change="eventNivelCl"
                      :disabled="inhabilitarNivelCl" autocomplete="off">
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12" sm="3" md="">
                    <v-autocomplete label="Grado" v-model="asociarCl.id_grado" :items="gradoContFilter"
                      :item-value="id_gradoFiltro" item-text="desc_grado" @change="eventGradoCl"
                      :disabled="inhabilitarGradoCl" autocomplete="off">
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12" sm="3" md="">
                    <v-autocomplete label="Área" v-model="asociarCl.id_area" :items="areaContFilter"
                      :item-value="id_areaFiltro" item-text="desc_area" @change="eventAreaCl"
                      :disabled="inhabilitarAreaCl" autocomplete="off">
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12" sm="3" md="">
                    <v-autocomplete label="Curso" v-model="asociarCl.curso" :items="cursoContFilter"
                      :item-value="id_cursoFiltro" item-text="desc_curso" @change="cargarClases()"
                      :disabled="inhabilitarCursoCl" autocomplete="off" return-object>
                    </v-autocomplete>
                    <!-- id_ref_curso -->
                  </v-col>

                  <v-col cols="12">

                    <ComundataTablecomp v-if="tablaCk1" whitSearch :headers="InteligenioProgHeadersClases"
                      :items="clases" item-key="item => item.id_clase" :loading="loadingSeleccionarClase"
                      :search="search_asociarCl">
                      <template v-slot>
                        <v-row dense>
                          <v-col cols="12" class="d-flex align-center">
                            <v-chip label small class="red--text">
                              <b>*Importante: </b>&nbsp; Cada tema desarrollado puede ser utilizado para una o más
                              clases de
                              acuerdo al
                              criterio del docente.
                            </v-chip>
                          </v-col>
                        </v-row>
                      </template>

                      <template v-slot:estadoValor="{ item }">
                        <!-- <pre>{{ clases }}</pre> -->
                        <!-- <pre>{{ item}}</pre> -->
                        <template v-if="item.secciones">
                          <v-tooltip v-for="sec in item.secciones" :key="sec.id" bottom
                            :color="sec.seccion_programada ? 'grey' : 'green'">
                            <template v-slot:activator="{ on, attrs }">
                              <v-avatar :color="sec.seccion_programada ? 'grey' : 'green'" class="mx-1" size="25"
                                v-bind="attrs" v-on="on">
                                <span class="white--text text-h8"> {{ sec.nombre_seccion }}</span>
                              </v-avatar>
                            </template>
                            <span>{{ sec.seccion_programada ? 'programada' : 'sin programar' }}</span>
                          </v-tooltip>
                        </template>

                        <template v-else>
                          <v-chip small color="red" text-color="white">
                            {{ 'Sin horario asignado' }}
                          </v-chip>
                        </template>

                      </template>

                      <template v-slot:programar="{ item }">
                        <!-- <pre>{{item}}</pre> -->

                        <v-chip v-if="!item.id_sesion_aprendizaje" small class="color_activo" color="red">
                          No existe sesión de aprendizaje
                        </v-chip>
                        <v-chip v-else-if="!validateIndicadores(item.sap_indicadores)" small class="color_activo"
                          color="red">
                          No existen indicadores
                        </v-chip>
                        <ButtonComp textButton="Programar" iconBut="fas fa-tasks"
                          @click="programarClase(item, asociarCl.contenidoTipo)"
                          v-else-if="item.clase_programada === 0 && item.id_sesion_aprendizaje" />

                      </template>

                      <template v-slot:action_ver="{ item }">
                        <ButtonComp v-if="componenteEvento.visualizar_submodulo"
                          @click="$emit('visor', item.id, asociarCl.contenidoTipo)" verButton tooltipText="Ver clase" />
                      </template>

                    </ComundataTablecomp>

                    <ComundataTablecomp v-else :headers="ColegioProgHeadersClases" :items="clasesColegio"
                      item-key="item => item.id" whitSearch :search="search_asociarCl"
                      :loading="loadingSeleccionarClase">
                      <template v-slot>
                        <v-row dense>
                          <v-col cols="12" class="d-flex align-center">
                            <v-chip small label class="red--text">
                              *Importante: Cada tema desarrollado puede ser utilizado para una o más clases de acuerdo
                              al
                              criterio del docente.
                            </v-chip>
                          </v-col>
                        </v-row>
                      </template>

                      <template v-slot:fechaCreacion="{ item }">
                        {{ item.fec_us_ing | filtroFecha }}
                      </template>

                      <template v-slot:estadoValor="{ item }">

                        <template v-if="item.secciones">
                          <v-tooltip v-for="sec in item.secciones" :key="sec.id" bottom
                            :color="sec.seccion_programada ? 'grey' : 'green'">
                            <template v-slot:activator="{ on, attrs }">
                              <v-avatar :color="sec.seccion_programada ? 'grey' : 'green'" class="mx-1" size="25"
                                v-bind="attrs" v-on="on">
                                <span class="white--text text-h8"> {{ sec.nombre_seccion }}</span>
                              </v-avatar>
                            </template>
                            <span>{{ sec.seccion_programada ? 'programada' : 'sin programar' }}</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-chip small color="red" text-color="white">
                            {{ 'Sin horario asignado' }}
                          </v-chip>
                        </template>
                      </template>

                      <template v-slot:programar="{ item }">

                        <div class="d-flex" v-if="item.clase_programada === 0 && item.id_sesion_aprendizaje">
                          <ButtonComp @click="programarClase(item, asociarCl.contenidoTipo)" textButton="Programar"
                            iconBut="fas fa-tasks" />

                          <v-menu v-model="menuRemplazarTema[item.id_temario]" :close-on-content-click="false"
                            :nudge-width="200" offset-x>
                            <template v-slot:activator="{ on, attrs }">
                              <span v-bind="attrs" v-on="on">
                                <v-tooltip bottom color="black">
                                  <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                                    <v-btn icon color="green" v-bind="tooltipAttrs" v-on="tooltipOn"
                                      @click="replaceTemaAdm(item)">
                                      <v-icon>mdi-cached</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Reemplazar tema </span>
                                </v-tooltip>
                              </span>
                            </template>

                            <v-system-bar color="primary" dark>
                              <v-icon left>mdi-cached</v-icon> Reemplazar tema:
                              <v-spacer></v-spacer>

                              <v-icon @click="menuRemplazarTema[item.id_temario] = false">mdi-close</v-icon>
                            </v-system-bar>

                            <v-card max-width="350">
                              <v-list>
                                <v-list-item>

                                  <v-list-item-avatar>
                                    <img src="@/assets/temaicon.png">
                                  </v-list-item-avatar>

                                  <v-list-item-content>
                                    <strong class="primary--text text-overline">{{ item.nombre_clase }}</strong>
                                  </v-list-item-content>

                                </v-list-item>
                              </v-list>

                              <v-divider></v-divider>
                              <v-list dense>
                                <v-list-item v-for="(tema, indexT) in clasesColegioReplace" :key="indexT">
                                  <v-list-item-content>
                                    <v-list-item-subtitle v-if="tema.datos_clase.length > 0" class="text--primary">
                                      <v-list-item-title class="font-weight-normal"><strong>UNIDAD: </strong> {{
                                        tema.nombre_tema
                                      }}</v-list-item-title>
                                      <v-radio-group v-model="GroupTema" dense class="mt-0" hide-details>

                                        <template v-for="(clase, indexC) in tema.datos_clase">
                                          <v-radio :key="indexC" :value="clase.id_clase" color="success"
                                            @change="eventReplaceTema(clase, item)">

                                            <template v-slot:label>
                                              <v-list-item-title class="font-weight-normal"> <strong
                                                  class="success--text">TEMA:</strong> {{ clase.nombre_clase
                                                  }}</v-list-item-title>
                                            </template>

                                          </v-radio>

                                        </template>

                                      </v-radio-group>

                                    </v-list-item-subtitle>

                                    <v-list-item-subtitle v-else>
                                      No hay temas para mostrar
                                    </v-list-item-subtitle>
                                  </v-list-item-content>
                                </v-list-item>
                              </v-list>

                              <v-card-actions class="text-center">
                                <v-spacer></v-spacer>

                                <!-- <v-btn text @click="menuRemplazarTema = false">
                                  Cancelar
                                </v-btn>
                                <v-btn color="primary" text @click="menuRemplazarTema = false">
                                  Reemplazar
                                </v-btn> -->
                              </v-card-actions>
                            </v-card>
                          </v-menu>
                        </div>

                        <v-chip v-else-if=!item.id_sesion_aprendizaje small class="color_activo" color="red">
                          No existe sesión de aprendizaje
                        </v-chip>

                      </template>

                      <template v-slot:action_ver="{ item }">
                        <ButtonComp v-if="componenteEvento.visualizar_submodulo"
                          @click="$emit('visor', item.id_clase, asociarCl.contenidoTipo)" verButton
                          tooltipText="Ver clase" />

                      </template>
                    </ComundataTablecomp>

                  </v-col>

                </v-row>

              </v-stepper-content>

              <v-stepper-content step="programarClase">

                <component :is="componenteProgramarClase" :compParametroP="datosProgClase" :estado="estadoProgClase"
                  @close="closeProgClase" @listener="listenPropsChild"></component>

                <v-btn class="animate__animated animate__pulse animate__infinite infinite" block text color="primary"
                  @click="openSesion = !openSesion">
                  <v-icon left> {{ openSesion ? 'fas fa-chevron-up' : 'fas fa-chevron-down' }}
                  </v-icon>
                  Ver sesión de aprendizaje
                </v-btn>

                <v-expand-transition>
                  <v-stepper v-model="stepper" v-show="openSesion">
                    <v-stepper-header>

                      <v-stepper-step editable step="1">
                        Datos generales <br /> Aprendizajes esperados
                      </v-stepper-step>

                      <v-divider></v-divider>

                      <v-stepper-step editable step="2">
                        Secuencia didáctica <br />
                        Referencias bibliográficas
                      </v-stepper-step>

                    </v-stepper-header>

                    <v-stepper-content step="1">

                      <component :is="componenteSesionAprendizaje" :parametros="datosSesionAprendizaje"
                        :idseccion="idseccionProp" :fecha="fechaProp" :estadoComp="estadoSesionAprendizaje"
                        @close="closeSesionAprendizaje" @listener="listenPropsChild"></component>



                    </v-stepper-content>

                    <v-stepper-content step="2">

                      <component :is="componenteSecuenciaDidactica" :parametros="datosSecuenciaDidactica"
                        :estadoComp="estadoSecuenciaDidactica"></component>

                    </v-stepper-content>
                  </v-stepper>
                </v-expand-transition>

              </v-stepper-content>

            </v-stepper-items>

          </v-stepper>

        </template>
      </ComunDialogComp>

    </v-form>
  </div>
</template>

<script>
import axios from "../../../../helpers/axios";
// eslint-disable-next-line no-unused-vars
import { mapMutations, mapGetters, mapActions } from "vuex";
import ComunDialogComp from "../../../../components/ComponentsEst/ComunDialogComp.vue";
// import AutocompleteComp from "../../../../components/ComponentsEst/AutocompleteComp.vue";
import ButtonComp from "../../../../components/ComponentsEst/TableButtonComp.vue";
import ComundataTablecomp from "../../../../components/ComponentsEst/ComundataTablecomp.vue";
import { InteligenioProgHeadersClases, ColegioProgHeadersClases } from "../../../../helpers/headersTable";
import ProgramarClase from "../components/programarClase/programarClase.vue";

import SesionAprendizajeComp from "../sesionAprendizaje/componentes/formSesionAprendizaje.vue";
import SecuenciaDidacticaComp from "../sesionAprendizaje/componentes/secuenciaDidactica.vue";

export default {
  name: "modalSeleccionarClaseTemas",
  props: ["estadoComp", "datosSelecClase", "actualizarConsulta"],
  components: {
    ComunDialogComp,
    ProgramarClase,
    // AutocompleteComp,
    ButtonComp,
    ComundataTablecomp,

    SesionAprendizajeComp,
    SecuenciaDidacticaComp
  },
  data: () => ({
    InteligenioProgHeadersClases,
    ColegioProgHeadersClases,
    openSesion: false,
    datoLogin: sessionStorage,
    asociarCl: {
      contenidoTipo: null,
      id_nivel: "",
      id_grado: "",
      id_area: "",
      id_curso: "",
    },
    next: 'seleccionarClase',
    search_asociarCl: "",
    inhabilitarNivelCl: true,
    inhabilitarGradoCl: true,
    inhabilitarAreaCl: true,
    inhabilitarCursoCl: true,
    tablaCk1: true,
    clases: [],

    sinIndicadores: true,

    tablaColegio: false,
    clasesColegio: [],

    clasesColegioReplace: [],

    nivelCont: [],
    id_nivelFiltro: "",
    id_gradoFiltro: "",
    id_areaFiltro: "",

    gradoCont: [],
    gradoContFilter: [],
    areaCont: [],
    areaContFilter: [],
    cursoCont: [],
    cursoContFilter: [],
    id_cursoFiltro: [],
    loadingSeleccionarClase: false,

    nivelContManager: [],
    gradoContManager: [],
    areaContManager: [],
    cursoContManager: [],
    nivelContColegio: [],

    // NUEVA LOGICA -- REFACTORIZACION 

    componenteProgramarClase: null,
    datosProgClase: [],
    estadoProgClase: false,

    componenteSesionAprendizaje: null,
    datosSesionAprendizaje: [],
    estadoSesionAprendizaje: false,

    componenteSecuenciaDidactica: null,
    datosSecuenciaDidactica: [],
    estadoSecuenciaDidactica: false,

    stepper: 1,
    idseccionProp: null,
    fechaProp: null,

    descargandoDocumento: false,

    menuRemplazarTema: {},
    GroupTema: []

  }),
  computed: {
    ...mapGetters("login", ["componenteEvento"]),

    validateIndicadores() {
      return (indicadores) => {
        if (!Array.isArray(indicadores)) return false;
        const seen = new Set();

        for (let indicador of indicadores) {
          if (!indicador.id_competencia || !indicador.id_capacidad || !indicador.id_indicador) return false;

          const key = `${indicador.id_competencia}-${indicador.id_capacidad}-${indicador.id_indicador}`

          if (seen.has(key)) return false;

          seen.add(key);
        }
        return true;
      }
    },
  },
  mounted() {
    this.loadMain();
  },
  watch: {
    // actualizarConsulta(valor) {
    //   if (valor) {
    //     if (this.datosSelecClase.evento != 'editar') {
    //       this.cargarClases();          
    //     }
    //   }
    // },
    estadoComp(valor) {
      if (valor) {
        this.loadMain();
      } else {
        this.limpiarData();
      }
    },
  },
  methods: {
    ...mapMutations({
      setEnviarMens: "mensajeSis/setEnviarMens",
    }),

    /** 
     __________________________________________
    |          MÉTODO CARGA INICIAL          */
    loadMain() {

      switch (this.datosSelecClase.evento) {

        case 'agregar':
          this.cargarContenidoSelectoresManager();
          this.cargarContenidoSelectoresColegio();
          this.next = 'seleccionarClase';
          break;

        case 'editar':

          this.componenteProgramarClase = "ProgramarClase";

          this.datosProgClase = {
            items: this.datosSelecClase.items,
            evento: "editar",
            ...this.asociarCl.curso,
            nivelDoc: this.datosSelecClase.nivelDoc,
            gradoDoc: this.datosSelecClase.gradoDoc,
            areaDoc: this.datosSelecClase.areaDoc,
            cursoDoc: this.datosSelecClase.cursoDoc,
            seccionDoc: this.datosSelecClase.seccionDoc,
            tipo_contenido: this.datosSelecClase.items.tipo_contenido,
          };

          this.estadoProgClase = true;

          this.openSesion = false;
          this.stepper = 1,
            this.callSesionAprendizaje(
              this.datosSelecClase.items,
              this.datosSelecClase.items.tipo_contenido,
              this.datosSelecClase.evento,
              this.datosSelecClase.items
            )

          this.next = 'programarClase';
          break;

        case 'ver':

          this.openSesion = true;
          this.estadoProgClase = false;
          this.stepper = 1,
            this.callSesionAprendizaje(
              this.datosSelecClase.items,
              this.datosSelecClase.items.tipo_contenido,
              this.datosSelecClase.evento,
              this.datosSelecClase.items
            )

          this.next = 'programarClase';
          break;

      }

    },
    /** 
     __________________________________________________________________
    |          MÉTODO PARA ABRIR COMPONENTE PROGRAMAR CLASE          */
    programarClase(item, tipoContenido) {

      this.stepper = 1,

        this.componenteProgramarClase = "ProgramarClase";

      this.datosProgClase = {
        items: item,
        evento: "agregar",
        ...this.asociarCl.curso,
        nivelDoc: this.datosSelecClase.nivelDoc,
        gradoDoc: this.datosSelecClase.gradoDoc,
        areaDoc: this.datosSelecClase.areaDoc,
        cursoDoc: this.datosSelecClase.cursoDoc,
        seccionDoc: this.datosSelecClase.seccionDoc,
        tipo_contenido: tipoContenido,
      };

      this.estadoProgClase = true;
      this.callSesionAprendizaje(item, tipoContenido, 'agregar', this.asociarCl.curso)
      this.next = 'programarClase'

    },
    /** 
     _____________________________________________________
    |          MÉTODO PARA REEMPLAZAR TEMAS ADM         */
    async replaceTemaAdm(items) {
      try {

        const { data } = await axios.get(`/administrativo/temario/${items.id_curso}/${0}`);

        this.clasesColegioReplace = data.map(e => {
          const filteredDatosClase = e.datos_clase.filter(el =>
            !this.clasesColegio.some(xl => xl.id_tema === e.id_tema && xl.id_clase === el.id_clase)
          );
          return { ...e, datos_clase: filteredDatosClase };
        }).filter(e => e.id_tema == items.id_tema);

        this.GroupTema = [];

      } catch (error) {
        console.log(error);
      }
    },
    /** 
     _________________________________________________________
    |          MÉTODO EJECUTAR REEMPLAZO DEL TEMA           */
    async eventReplaceTema(items, itemsDelete) {

      try {
        const { status } = await axios.put(`/administrativo/temario/updateclasestemario/${itemsDelete.id_temario}`, {
          id_clase: items.id_clase,
          nombre_clase: items.nombre_clase
        });
        this.menuRemplazarTema[itemsDelete.id_temario] = false;
        if (status === 200) {
          this.setEnviarMens({
            tipo: "S",
            mensaje: `Tema reemplazado con éxito`,
            tiempo: 1000,
          });
        }
      }
      catch (error) {
        console.log(error);
      } finally {
        this.cargarClases();
      }
    },
    /** 
     _______________________________________________________________________________________
    |          MÉTODO INVOCAR A LA SESION DE APRENDIZAJES Y SECUENCIAS DIDACTICAS         */
    callSesionAprendizaje(item, tipoContenido, evento, datos) {

      this.componenteSesionAprendizaje = "SesionAprendizajeComp";

      this.datosSesionAprendizaje = {
        items: item,
        evento: evento,
        ...datos,
        nivelDoc: this.datosSelecClase.nivelDoc,
        gradoDoc: this.datosSelecClase.gradoDoc,
        areaDoc: this.datosSelecClase.areaDoc,
        cursoDoc: this.datosSelecClase.cursoDoc,
        seccionDoc: this.datosSelecClase.seccionDoc,
        tipo_contenido: tipoContenido,
      };

      this.estadoSesionAprendizaje = true;

      this.componenteSecuenciaDidactica = "SecuenciaDidacticaComp";

      this.datosSecuenciaDidactica = {
        items: item,
        evento: evento,
        ...datos,
        nivelDoc: this.datosSelecClase.nivelDoc,
        gradoDoc: this.datosSelecClase.gradoDoc,
        areaDoc: this.datosSelecClase.areaDoc,
        cursoDoc: this.datosSelecClase.cursoDoc,
        seccionDoc: this.datosSelecClase.seccionDoc,
        tipo_contenido: tipoContenido,
      };

      this.estadoSecuenciaDidactica = true;

    },

    /** 
     _______________________________________________________________________
    |          MÉTODO RECIBIR IDSECCION DE PROGCLASE A SESIONAPRE         */
    listenPropsChild(action, valor) {

      switch (action) {

        case 'setidSeccion':
          this.idseccionProp = valor;
          break;


        case 'setFecha':
          this.fechaProp = valor;
          break;


        case 'returnBack':
          this.returnBack();
          break;

      }

    },
    cerrarModal() {

      this.estadoProgClase = false;
      this.datosProgClase = {};

      this.datosSesionAprendizaje = {};
      this.estadoSesionAprendizaje = false;

      this.datosSecuenciaDidactica = {};
      this.estadoSecuenciaDidactica = false;

      this.$emit("close");
      // this.$emit("cargarmain");
      this.next = 'seleccionarClase';

    },

    limpiarData() {
      this.openSesion = false;
      this.asociarCl = {
        contenidoTipo: null,
        id_nivel: "",
        id_grado: "",
        id_area: "",
        id_curso: "",
      };
      this.next = 'seleccionarClase';
      this.search_asociarCl = "";
      this.inhabilitarNivelCl = true;
      this.inhabilitarGradoCl = true;
      this.inhabilitarAreaCl = true;
      this.inhabilitarCursoCl = true;
      this.tablaCk1 = true;
      this.clases = [];
      this.tablaColegio = false;
      this.clasesColegio = [];
      this.nivelCont = [];
      this.id_nivelFiltro = "";
      this.id_gradoFiltro = "";
      this.id_areaFiltro = "";
      this.gradoCont = [];
      this.gradoContFilter = [];
      this.areaCont = [];
      this.areaContFilter = [];
      this.cursoCont = [];
      this.cursoContFilter = [];
      this.id_cursoFiltro = [];
      this.loadingSeleccionarClase = false;
      this.nivelContManager = [];
      this.gradoContManager = [];
      this.areaContManager = [];
      this.cursoContManager = [];
      this.nivelContColegio = [];
      this.componenteProgramarClase = null;
      this.datosProgClase = [];
      this.estadoProgClase = false;
      this.componenteSesionAprendizaje = null;
      this.datosSesionAprendizaje = [];
      this.estadoSesionAprendizaje = false;
      this.componenteSecuenciaDidactica = null;
      this.datosSecuenciaDidactica = [];
      this.estadoSecuenciaDidactica = false;
      this.stepper = 1;
      this.idseccionProp = null;
      this.fechaProp = null;
    },

    /** 
 ________________________________________________________________
|          MÉTODO CARGAR CONTENIDO SELECTORES MANAGER          */
    async cargarContenidoSelectoresManager() {

      let response = await axios.post(
        `/academico/progDocente/getQueryContCk1`,
        {
          id_usuario: this.datoLogin.id,
          id_colegio: this.datoLogin.id_colegio,
          id_periodo: this.datoLogin.id_ano_lectivo,
        }
      );

      this.nivelContManager = response.data.NivelCkOne;
      this.gradoContManager = response.data.GradoCkOne;
      this.areaContManager = response.data.AreaCkOne;
      this.cursoContManager = response.data.CursoCkOne;

    },

    /** 
     ________________________________________________________________
    |          MÉTODO CARGAR CONTENIDO SELECTORES COLEGIO          */
    cargarContenidoSelectoresColegio() {
      this.nivelContColegio = this.datosSelecClase.nivelDoc;
      this.gradoContColegio = this.datosSelecClase.gradoDoc;
      this.areaContColegio = this.datosSelecClase.areaDoc;
      this.cursoContColegio = this.datosSelecClase.cursoDoc;
    },
    /** 
     ______________________________________________________________________________
    |          MÉTODO CARGAR CONTENIDO DE RADIOS BUTTON PARA SELECTORES          */
    async cargarQueryContenido(idcontenido) {

      this.clases = [];

      this.asociarCl.id_nivel = idcontenido == 1 ? "" : this.datosSelecClase.id_nivel;
      this.asociarCl.id_grado = idcontenido == 1 ? "" : this.datosSelecClase.id_grado;
      this.asociarCl.id_area = idcontenido == 1 ? "" : this.datosSelecClase.id_area;
      this.asociarCl.curso = {}

      this.inhabilitarNivelCl = false;
      this.inhabilitarGradoCl = true;
      this.inhabilitarAreaCl = true;
      this.inhabilitarCursoCl = true;

      this.id_nivelFiltro = idcontenido == 1 ? "id" : "id_nivel";
      this.id_gradoFiltro = idcontenido == 1 ? "id" : "id_grado";
      this.id_areaFiltro = idcontenido == 1 ? "id" : "id_area";
      this.id_cursoFiltro = "id";
      this.tablaCk1 = idcontenido == 1 ? true : false;
      this.tablaColegio = idcontenido == 1 ? false : true;

      this.nivelCont = idcontenido == 1 ? this.nivelContManager : this.nivelContColegio
      this.gradoCont = idcontenido == 1 ? this.gradoContManager : this.gradoContColegio
      this.areaCont = idcontenido == 1 ? this.areaContManager : this.areaContColegio
      this.cursoCont = idcontenido == 1 ? this.cursoContManager : this.cursoContColegio
    },



    async cargarClases() {


      console.log('da', this.asociarCl);


      this.asociarCl.periodo = this.datoLogin.id_ano_lectivo
      this.asociarCl.id_colegio = this.datoLogin.id_colegio
      this.asociarCl.id_persona = this.datoLogin.id_persona
      this.asociarCl.id_curso = this.asociarCl.contenidoTipo == 0 ? this.asociarCl.curso.id : this.asociarCl.curso.id_ck1_curso;

      try {
        this.loadingSeleccionarClase = true;
        this.next = 'seleccionarClase';
        if (this.asociarCl.contenidoTipo == "1") {

          let response = await axios.post(
            `/academico/progDocente/getClasesCk1`,
            this.asociarCl
          );

          console.log({ response });

          // setTimeout(() => {

          this.clases = response.data.payload;
          this.loadingSeleccionarClase = false;

          // }, 150);

        } else if (this.asociarCl.contenidoTipo == "0") {   // contenido del colegio

          let response = await axios.get(
            `/academico/progDocente/getContenidoColegio/periodo/${this.datoLogin.id_ano_lectivo}/colegio/${this.datoLogin.id_colegio}/area/${this.asociarCl.id_area}/curso/${this.asociarCl.id_curso}/persona/${this.datoLogin.id_persona}/${this.asociarCl.id_periodo_actual}`
          );

          // setTimeout(() => {
          this.clasesColegio = response.data.payload.ContenidoColegio;

          this.loadingSeleccionarClase = false;
          this.next = 'seleccionarClase';
          // }, 150);

        }
      } catch (error) {
        console.log(error)
        this.setEnviarMens({
          tipo: "E",
          mensaje: `Error: ${error}`,
          tiempo: null,
        });
      }
    },

    async eventNivelCl(event) {

      let result = [];

      if (this.asociarCl.contenidoTipo == 1) {
        result = this.nivelContColegio.filter(el => el.id_nivel_clickone == event)
      } else {
        result = this.nivelContColegio.filter(el => el.id_nivel == event)
      }

      this.inhabilitarGradoCl = false;
      this.inhabilitarAreaCl = true;
      this.inhabilitarCursoCl = true;
      this.clases = [];
      this.clasesColegio = [];

      // filtro y cargo los valores del grado segun el nivel
      this.gradoContFilter = this.gradoCont.filter(
        (el) => el.id_nivel == this.asociarCl.id_nivel
      );
      // id_colegio, id_ano_lectivo, id_adm_nivel
      // let params = {
      //   id_colegio: Number(this.datoLogin.id_colegio),
      //   id_ano_lectivo: Number(this.datoLogin.id_ano_lectivo),
      //   id_adm_nivel: result[0].id_nivel
      // }
      try {
        let response = await axios.get(`administrativo/periodo/periodoActualActivo/${Number(this.datoLogin.id_colegio)}/${Number(this.datoLogin.id_ano_lectivo)}/${result[0].id_nivel}`);

        this.asociarCl.id_periodo_actual = response.data;

      } catch (error) {
        console.log(error);
      }

    },

    eventGradoCl() {
      this.inhabilitarAreaCl = false;
      this.inhabilitarCursoCl = true;
      this.asociarCl.id_area = "";
      this.asociarCl.id_curso = "";
      this.clases = [];
      this.clasesColegio = [];

      if (this.asociarCl.contenidoTipo == "1") {
        this.areaContFilter = this.areaCont.filter(
          (el) =>
            el.id_nivel == this.asociarCl.id_nivel &&
            el.id_grado == this.asociarCl.id_grado
        );
      }

      // contenido del colegio
      else if (this.asociarCl.contenidoTipo == "0") {
        this.areaContFilter = this.areaCont.filter(
          (el) => el.id_grado == this.asociarCl.id_grado
        );
      }
    },

    eventAreaCl() {

      this.asociarCl.id_curso = "";
      this.inhabilitarCursoCl = false;

      this.clases = [];
      this.clasesColegio = [];

      if (this.asociarCl.contenidoTipo == 1) { //Inteligenio

        console.log(this.datosSelecClase);
        console.log('otra vaina', this.asociarCl);


        let resultFiltroCurso = this.datosSelecClase.cursoDoc.filter(
          (el) => el.id_area_clickone == this.asociarCl.id_area
        );

        console.log({ resultFiltroCurso });

        this.cursoContFilter = resultFiltroCurso.filter(
          (el) => el.id_grado_clickone == this.asociarCl.id_grado
        );



        console.log({ cursoContFilter: this.cursoContFilter });






      } else {

        let resultFiltroCurso = this.datosSelecClase.cursoDoc.filter(el => el.id_area == this.asociarCl.id_area);

        this.cursoContFilter = resultFiltroCurso.filter(
          (el) => el.id_grado == this.asociarCl.id_grado
        );

      }

    },

    // NUEVA LOGICA REFACTORIZADA 
    /** 
     ________________________________________________
    |          MÉTODO EMIT SIGUIENTE PASO          */
    closeProgClase() {
      this.$emit("cargarmain");
      // this.estadoProgClase = false;
      // this.estadoSesionAprendizaje = false;
      // this.estadoSecuenciaDidactica = false;    
      this.idseccionProp = null;
      this.fechaProp = null;
      this.$emit("close");
    },
    /** 
     ______________________________________________________
    |          MÉTODO VOLVER A SELECIONAR CLASE          */
    returnBack() {
      this.cargarClases();
      this.estadoProgClase = false;
      this.estadoSesionAprendizaje = false;
      this.estadoSecuenciaDidactica = false;
      this.openSesion = false;
      this.idseccionProp = null;
      this.fechaProp = null;
      this.$emit("cargarmain");
    },
    /** 
     ______________________________________________________
    |          MÉTODO CERRAR SESION APRENDIZAJE          */
    closeSesionAprendizaje() {
      console.log('cerrar sesion aprendizaje');
    },
    /** 
     _________________________________________________________
    |          MÉTODO DESCARGAR SESION APRENDIZAJE          */
    async GenerarDocumento() {

      try {
        this.descargandoDocumento = true;
        const params = {
          id_colegio: this.datoLogin.id_colegio,
        };
        // this.datosSA.id_usuario = this.datoLogin.id;s
        let url = `/academico/sesionAprendizajeProg/${this.datosSelecClase.items.id_sesion_aprendizaje}/documento/`;
        let res = await axios.post(url, params, { responseType: "blob" });
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute(
          "download",
          `sesion_aprendizaje_${this.datosSelecClase.items.id_sesion_aprendizaje}.pdf`
        );
        document.body.appendChild(fileLink);

        fileLink.click();
        // this.setEnviarMens({ tipo: res.data.messageT, mensaje: res.data.message, tiempo: 6000})
      } catch (error) {
        console.log(error);
        this.setEnviarMens({
          tipo: "E",
          mensaje: `Error al generar el documento`,
          tiempo: null,
        });
      }
      this.descargandoDocumento = false;
    },


  },
};
</script>

<style>
.v-skeleton-loader.skeletonTic.v-skeleton-loader--is-loading.theme--light {
  display: flex;
  justify-content: space-between;
  padding: 1px;
}

.skeletonTic>.v-skeleton-loader__avatar {
  width: 28px;
  height: 28px;
}

.skeletonTic>.v-skeleton-loader__text.v-skeleton-loader__bone {
  width: 70px;
  margin: 8px;
}

.sesionclass>.v-expansion-panel-content__wrap {
  padding: 0px !important;
}
</style>
